import { IFlowEventData } from 'types/analytics';
import { trackingFlowSubTypes } from 'constants/analytics';
import { WIDGET_NAME } from '@sitegen/common/constants';

export const TEXT_KEYS = {
    REDEEM_ITEM_TITLE: 'redeem-items-display-page__game-selector__title',
    REDEEM_ITEM_NOT_AVAILABLE: 'redeem-items-display-page__game-selector__not-available'
};

export const ITEMS_DISPLAY_FLOW_STEP: Pick<IFlowEventData, 'flowStep'|'flowSubType'> = {
    flowStep: 'item display',
    flowSubType: trackingFlowSubTypes[WIDGET_NAME.PYC_REDEEM]
};

export const ITEMS_DISPLAY_SELECT_ACTION = (name: string) => `item selection: ${name}`;

export const enum ITEMS_ALIGNMENT {
    CENTER = 'align-center',
    LEFT = 'align-left'
}

export const MAX_CENTERED_ITEMS: number = 2;
